export default function ({ app }) {
  app.router.afterEach((to, from) => {
    if (window.vgo) {
      window.vgo('update')
      window.vgo('process')
    }
  })
}
